module.exports = __webpack_public_path__ + "static/capstone_gatech-6792ad0eed0124b56c79dd7bd051bad1.jpg";